<template>
  <div class="body-container cashValue-jdf-pd">
    <table>
      <tr class="th">
        <td>生成时间</td>
        <td>批单</td>
      </tr>
      <tr v-for="(item, i) in list" :key="i">
        <td>{{ setTime(item.creatTime,'-') }}</td>
        <td class="blue" @click="showPd(item.addPolicyUrl)">查看批单</td>
      </tr>
    </table>
  </div>
</template>
<script>
//当前实例组件
var vm = null;
export default {
  data: () => ({
    list: [1],
  }),
  components: {},
  mounted() {
    this.getData();
  },
  created() {
    vm = this;
  },
  methods: {
    getData() {
      this.$http({
        url: "/policy/V5/api/addpolicyUrlList",
        data: { policyNo: this.$route.query.policyNo },
      })
        .then((data) => {
          this.list = data.data;
        })
        .catch((err) => {});
    },

    showPd(url) {
      if (vm.$tools.isWtsNativeApp()) {
        nativeApp.general.deviceready(function () {
          nativeApp.general.readPdf({
            url: url
          });
        });
        return;
      }
      location.href = url;
    },

    setTime(timestamp, type) {
      var date = new Date(timestamp.replace(/-/gm, "/"));
      function addZero(num) {
        if (num < 10) return "0" + num;
        return num;
      }
      // 按自定义拼接格式返回
      return (
        date.getFullYear() +
        type +
        addZero(date.getMonth() + 1) +
        type +
        addZero(date.getDate())
      );
    },
  },
};
</script>
<style lang="scss">
.cashValue-jdf-pd {
  width: 100%;
  height: 100vh;
  background: #fff;
  padding: 30px;
  table {
    width: 100%;
    border: 1px solid #dee2ea;
    .th {
      td {
        color: #666e7b;
        background: #f9fafb;
      }
    }
    td {
      width: 33.3333%;
      padding: 15px 0px;
      border: 1px solid #dee2ea;
      font-size: 24px;
      color: #000;
      &.blue{
        color: #236DFF;
      }
    }
    tr {
      text-align: center;
    }
  }
}
</style>